import React from "react";
import styled from "styled-components";

import { Link } from "react-router-dom";

import { Button, MenuItem, Tooltip } from "@material-ui/core";

import { StyledInput, Highlight } from "../../../Styled-Components/styles";
import { getCarbonOffset } from "../../../Functions/functions";

const Menu = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  font-size: 22px;
  font-weight: 600;

  background-color: ${(props) => props.theme.palette.primary.main};
  color: white;

  border-radius: ${(props) => props.theme.border.radius};
  box-shadow: ${(props) => props.theme.border.shadow + props.theme.palette.primary.main};

  padding: 1vh 1vh;
  width: 12vw;
  min-width: 275px;
`;

const Field = styled.div`
  margin: 0 1vw 1vw 1vw;
  width: 8vw;
  min-width: 80px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  margin: 2vh 0;
`;

const StyledText = styled.div`
  font-weight: 600 !important;
  color: ${(props) => props.theme.palette.secondary.light}!important;
`;
const H4 = styled.h4`
  font-size: 20px;
  margin: 0;
  padding: 1vh 0;
`;
const StyledButton = styled(Button)`
  &.MuiButton-root {
    color: ${(props) => props.theme.palette.primary.dark};
    background-color: ${(props) => props.theme.palette.yellow.light};
    font-weight: 700;
  }
  &.MuiButton-root:hover {
    color: ${(props) => props.theme.palette.primary.dark};
    background-color: ${(props) => props.theme.palette.yellow.main};
    box-shadow: ${(props) => props.theme.border.shadow + props.theme.palette.primary.dark};
  }
`;

const ControlPanel = (props) => {
  return (
    <Menu>
      <Row>
        <H4>Your Contribution</H4>

        <StyledInput
          disableUnderline={true}
          value={props.payment}
          type="number"
          inputProps={{ inputMode: "decimal" }}
          startAdornment={<div>{"£ "}</div>}
          onChange={(event) => props.setPayment(event.target.value)}
        />
        <MenuItem component={Link} to="/donation">
          <StyledButton>Donate Now</StyledButton>
        </MenuItem>
      </Row>
      <Row>
        <div>
          Donated:{" "}
          <Highlight>{`£ ${
            parseInt(props.payment) + parseInt(props.totalDonations) || 0
          }`}</Highlight>
        </div>
        <div>
          Trees Planted: <Highlight>{`${props.treesPlanted.toLocaleString()}`}</Highlight>
        </div>
        <div>
          Carbon Offset:{" "}
          <Tooltip title="This is an estimate in tonnes of CO₂" arrow>
            <Highlight>
              {Math.round(
                getCarbonOffset(
                  parseInt(props.payment) + parseInt(props.totalDonations) || 0,
                  "tonnes"
                )
              ).toLocaleString()}{" "}
              T
            </Highlight>
          </Tooltip>
        </div>
      </Row>
    </Menu>
  );
};

export default ControlPanel;
